import { msg } from "@lingui/core/macro";
import { Show } from "solid-js";
import { Trash2, User as UserIcon } from "@fleet/icons";
import { Button } from "@/components/ui/button";
import { ConfirmDialog } from "@/components/ui/confirm-dialog";
import { useI18n } from "@/providers/i18n-provider";

interface Member {
  id: string;
  role: string;
  user: {
    name: string | null;
    email: string;
  };
}

interface OrganizationMemberRowProps {
  member: Member;
  onRemove: (memberId: string) => void;
}

export function OrganizationMemberRow(props: OrganizationMemberRowProps) {
  const { t } = useI18n();

  return (
    <div class="group flex items-center justify-between rounded-lg border border-transparent p-2 hover:bg-muted/50 transition-colors">
      <div class="flex items-center gap-3">
        <div class="flex h-9 w-9 items-center justify-center rounded-full bg-primary/10 text-primary">
          <UserIcon class="h-4 w-4" />
        </div>
        <div>
          <p class="text-sm font-medium">{props.member.user.name ?? props.member.user.email}</p>
          <p class="text-xs text-muted-foreground capitalize">{props.member.role}</p>
        </div>
      </div>
      <Show when={props.member.role !== "owner"}>
        <ConfirmDialog
          title={t(msg`Remove member?`)}
          description={t(msg`Are you sure you want to remove this user from the organization?`)}
          confirmLabel={t(msg`Remove`)}
          variant="destructive"
          onConfirm={() => {
            props.onRemove(props.member.id);
          }}
          renderTrigger={(open) => (
            <Button
              variant="ghost"
              size="icon"
              class="h-8 w-8 text-destructive opacity-0 group-hover:opacity-100 transition-opacity"
              onClick={open}
            >
              <Trash2 class="h-4 w-4" />
            </Button>
          )}
        />
      </Show>
    </div>
  );
}
